import { render, staticRenderFns } from "./CaptureSignature.vue?vue&type=template&id=5893c172&scoped=true&"
import script from "./CaptureSignature.vue?vue&type=script&lang=js&"
export * from "./CaptureSignature.vue?vue&type=script&lang=js&"
import style0 from "./CaptureSignature.vue?vue&type=style&index=0&id=5893c172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5893c172",
  null
  
)

export default component.exports